import { Plus, Trash2, ChevronUp, ChevronDown, Eye, EyeOff } from "lucide-react";

export default function ItemListEditor({ items, onChange, addLabel = "Aggiungi elemento", testid }) {
  const list = items || [];
  const update = (idx, patch) => {
    const next = [...list];
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  };
  const move = (idx, dir) => {
    const next = [...list];
    const j = idx + dir;
    if (j < 0 || j >= next.length) return;
    [next[idx], next[j]] = [next[j], next[idx]];
    onChange(next);
  };
  const remove = (idx) => {
    if (!window.confirm("Rimuovere questo elemento?")) return;
    onChange(list.filter((_, i) => i !== idx));
  };
  const add = () => {
    onChange([
      ...list,
      { id: `it-${Date.now()}`, label: "", value: "", enabled: true },
    ]);
  };

  return (
    <div data-testid={testid} className="space-y-3">
      {list.map((it, idx) => (
        <div
          key={it.id}
          data-testid={`${testid}-row-${it.id}`}
          className={`border ${
            it.enabled === false ? "border-dashed opacity-60" : ""
          } border-[color:var(--tr-border)] bg-[color:var(--tr-bg)] p-4`}
        >
          <div className="grid grid-cols-12 gap-3 items-center">
            <div className="col-span-12 sm:col-span-3">
              <span className="label-eyebrow">Etichetta</span>
              <input
                value={it.label || ""}
                onChange={(e) => update(idx, { label: e.target.value })}
                placeholder="es. Email"
                className="tr-field !py-1.5"
              />
            </div>
            <div className="col-span-12 sm:col-span-6">
              <span className="label-eyebrow">Valore</span>
              <input
                value={it.value || ""}
                onChange={(e) => update(idx, { value: e.target.value })}
                placeholder="es. atelier@trame.studio"
                className="tr-field !py-1.5"
              />
            </div>
            <div className="col-span-12 sm:col-span-3 flex items-center gap-1 sm:justify-end">
              <button
                onClick={() => move(idx, -1)}
                disabled={idx === 0}
                className="p-2 hover:bg-[color:var(--tr-bg-2)] disabled:opacity-25"
                aria-label="Su"
              >
                <ChevronUp className="w-4 h-4" strokeWidth={1.5} />
              </button>
              <button
                onClick={() => move(idx, 1)}
                disabled={idx === list.length - 1}
                className="p-2 hover:bg-[color:var(--tr-bg-2)] disabled:opacity-25"
                aria-label="Giù"
              >
                <ChevronDown className="w-4 h-4" strokeWidth={1.5} />
              </button>
              <button
                onClick={() => update(idx, { enabled: it.enabled === false })}
                className="p-2 hover:bg-[color:var(--tr-bg-2)]"
                aria-label={it.enabled === false ? "Mostra" : "Nascondi"}
                title={it.enabled === false ? "Mostra" : "Nascondi"}
              >
                {it.enabled === false ? (
                  <EyeOff className="w-4 h-4 text-[color:var(--tr-ink-soft)]" strokeWidth={1.5} />
                ) : (
                  <Eye className="w-4 h-4" strokeWidth={1.5} />
                )}
              </button>
              <button
                onClick={() => remove(idx)}
                className="p-2 hover:bg-red-50 text-red-700"
                aria-label="Elimina"
              >
                <Trash2 className="w-4 h-4" strokeWidth={1.5} />
              </button>
            </div>
          </div>
        </div>
      ))}
      <button
        onClick={add}
        className="tr-btn-ghost inline-flex items-center gap-2"
        data-testid={`${testid}-add`}
      >
        <Plus className="w-4 h-4" />
        {addLabel}
      </button>
    </div>
  );
}
